(ns app.front.view.archiving.components
  (:require [app.domain.archiving.model :as archiving-model]
            [app.front.ui :as ui]
            [app.front.ui.select :as ui-select]
            [app.front.util :as futil]))


(defmulti archiving-field-input (fn [{:keys [:archiving-field-schema/input-type]} _] input-type))


(defmethod archiving-field-input :number-input [_ {:keys [value on-change id tr label disabled required]}]
  [:div.mt-4 {:class "sm:w-full lg:w-1/2 xl:w-1/3 xxl:w-1/4"}
   [ui/number-input
    {:id         (str id "-number-input")
     :label-text (tr [label])
     :value      value
     :on-change  #(-> % futil/tval futil/parse-int on-change)
     :disabled   (boolean disabled)
     :required   (boolean required)}]])


(defmethod archiving-field-input :date-picker [_ {:keys [value on-change id tr label required disabled]}]
  [:div.bx--form-item.mt-4 {:class "sm:w-full lg:w-1/2 xl:w-1/3 xxl:w-1/4"}
   [ui/date-picker
    {:id         (str id "-date-picker")
     :label-text (tr [label])
     :value      value
     :width      "197px"
     :required?  (boolean required)
     :disabled?  (boolean disabled)
     :callback   on-change}]])


(defmethod archiving-field-input :select [{:archiving-field-schema/keys [manual-input-config] :as schema}
                                          {:keys [value selected-value on-change disabled config-view?
                                                  on-change-for-select id tr required]                 :as ctx}]
  (let [on-change                                               (or on-change-for-select on-change)
        {:keys [input-type label hide-for-config? option-name]} manual-input-config]
    [:<>
     [:div.mt-4 {:class (if config-view?
                          "mr-4"
                          "sm:w-full lg:w-1/2 xl:w-1/3 xxl:w-1/4")}
      [ui-select/select
       {:id           id
        :label-text   (tr [(:label ctx)])
        :values       (archiving-model/get-values-for-select schema)
        :val->str     #(if (= % :archiving/manual-input)
                         (tr [option-name])
                         (tr [%]))
        :class-name   "archiving-field-select"
        :allow-empty? false
        :on-change    on-change
        :disabled     (boolean disabled)
        :required     (boolean required)
        :value        selected-value}]]
     (when (and (or (not config-view?)
                    (not hide-for-config?))
                (archiving-model/manual-input-is-visible? selected-value))
       (archiving-field-input {:archiving-field-schema/input-type input-type}
                              (cond-> (assoc ctx :label label)
                                      ;Do not display selected value for the second input
                                (= value selected-value) (dissoc :value))))]))
